const roundNumber = (num: number, decimalPlaces: number) => {
  const factorOfTen = Math.pow(10, decimalPlaces)

  return Math.round(num * factorOfTen) / factorOfTen
}

/**
 * Rounds up to the nearest 0.5 increment
 */
const ceilToNearestHalf = (num: number) => Math.ceil(num * 2) / 2

/**
 *  Get total of a key in an array of objects
 */
const getTotal = <T, K extends keyof T>(arr: Array<T>, key: K): number => {
  return arr.reduce((acc, curentObject) => {
    const value = curentObject[key]

    if (typeof value === 'number') {
      return acc + value
    } else if (!value) {
      return acc
    } else {
      throw new Error(`Value of ${String(key)} is not a number`)
    }
  }, 0)
}

export { roundNumber, ceilToNearestHalf, getTotal }
